import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';

type Collection<T> = T | Collection<T>[] | {[property: string]: Collection<T>};

export default function includesDeep<T>(haystack: Collection<T>, needle: T): boolean {
    if (isEqual(haystack, needle)) {
        return true;
    } else if (isArray(haystack)) {
        for (const value of haystack) {
            if (includesDeep(value, needle)) return true;
        }
    } else if (isObject(haystack)) {
        for (const key in haystack) {
            if (includesDeep(haystack[key], needle)) return true;
        }
    }

    return false;
}
